import React from 'react';
import { KYCCountry } from '@huspy/forge/types';
import { Skeleton } from '@mantine/core';
import { CaseCreationVaultFillFormsRoute } from '@modules/opportunities/presentation/routes';
import useKYCData from '@modules/vault/hooks/queries/useKYCData';
import { useGetBanks } from '@modules/banks/hooks/queries/useGetBanks';
import { useGetVaultStorage } from '@modules/vault/hooks/queries/useGetVaultStorage';
import { convertToApplicantType } from './utils';
import Form from './Form';

// eslint-disable-next-line react/display-name
export const VaultForm = React.memo(() => {
  const { opportunityId } = CaseCreationVaultFillFormsRoute.useParams();

  const { data, isLoading: isKYCDataLoading } = useKYCData<KYCCountry>(opportunityId);
  const { data: banksData, isLoading: isBankLoading } = useGetBanks();
  const {
    data: vaultStorageData,
    isClientNotLoggedIn,
    isLoading: isVaultStorageLoading,
  } = useGetVaultStorage(
    opportunityId
  );

  const applicantsKYC = vaultStorageData?.vault_status === 'draft'
    ? vaultStorageData?.vault_data_json.applicants : convertToApplicantType(data.kyc);

  const banks = banksData?.map((item) => ({ label: item.title, value: item.title })) || [];

  if (isKYCDataLoading || isBankLoading || isVaultStorageLoading) {
    return (
      <Skeleton
        data-test='vault-form-skeleton'
        w='100%'
        height={ 500 }
        radius='8px'
      />
    );
  }

  return (
    <Form
      opportunityId={ opportunityId }
      applicantsKYC={ applicantsKYC }
      banks={ banks }
      isClientNotLoggedIn={ isClientNotLoggedIn }
      isVaultSubmitted={ vaultStorageData?.vault_status === 'submitted' }
      isVaultDisabled={ vaultStorageData?.vault_status === 'disabled' }
    />
  );
});
